import React from 'react';
import { FormattedMessage } from 'react-intl';
import ButtonLink from 'components/common/ButtonLink';
import { StyledPipe } from './StyledPipe';
import { CLEAR_DEVELOPER_LICENSE } from '../../../duck/actions/license';
import { useDispatch } from 'react-redux';

export const ViewDeveloperLicense = ({
  setIsModalOpened,
}: {
  setIsModalOpened: (isOpened: boolean) => void;
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <ButtonLink
        onClick={() => {
          dispatch({ type: CLEAR_DEVELOPER_LICENSE });
          setIsModalOpened(true);
        }}
        data-cy="actions-section-view-developer-license-button"
      >
        <FormattedMessage
          id="mac.licenses.view.developer.license"
          defaultMessage="View Developer License"
        />
      </ButtonLink>
      <StyledPipe />
    </>
  );
};
